import { COMPETITION, COMPETITION_START_DATE, formatStartDate } from "../Constant/competition";
import { PRIZES } from "./prizes";
import {
  buildLeaderboardRows,
  INITIAL_BALANCE,
  LEADERBOARD_SEED,
  tickEquity,
} from "./leaderboard";

const startDateFormatted = formatStartDate(COMPETITION_START_DATE);

/** Matches live socket tick cadence (~3s). */
export const STATIC_TICK_MS = 3000;

/** Brief delay so static loads feel like a real API fetch. */
export const STATIC_FETCH_DELAY_MS = 600;

/** API-shaped competition payload for frontend-only runs. */
export const STATIC_COMPETITION = {
  id: "static-demo",
  brandName: COMPETITION.brandName,
  tagline: COMPETITION.tagline,
  title: COMPETITION.title,
  startDate: COMPETITION_START_DATE,
  startDateFormatted,
  startDateLabel: COMPETITION.startDateLabel,
  endDate: COMPETITION.endDate,
  endDateFormatted: formatStartDate(COMPETITION.endDate),
  endDateLabel: COMPETITION.endDateLabel,
  countdownMode: COMPETITION.countdownMode,
  countdownTarget: COMPETITION.countdownTarget,
  totalPrizePool: COMPETITION.totalPrizePool,
  startingBalance: "$10,000",
  duration: "1 Month",
  currency: COMPETITION.currency,
  participateUrl: COMPETITION.participateUrl,
  howItWorksUrl: COMPETITION.howItWorksUrl,
  // Terms PDF always comes from the backend `/terms-pdf` stream (not a static file).
  termsConditionsUrl: null,
  hasTermsConditions: true,
  extraUrl: null,
  teamId: null,
  countryEligible: true,
  ipCountry: null,
  stats: [
    { key: "duration", value: "1 Month" },
    { key: "startingBalance", value: "$10,000" },
    { key: "entry", valueKey: "entryValue", highlight: true },
    { key: "accounts", valueKey: "accountsValue" },
  ],
};

export const STATIC_PRIZES = PRIZES;

export const STATIC_OVERVIEW = {
  competition: STATIC_COMPETITION,
  prizes: STATIC_PRIZES,
  competitionId: STATIC_COMPETITION.id,
};

const createParticipants = () =>
  LEADERBOARD_SEED.map((row, index) => ({
    ...row,
    mt5Login: 900000 + index + 1,
    maxDrawdownPct: 0,
    roundTurnTrades: 8,
  }));

/** Mutable equity state so ticks feel like a live feed. */
let participants = createParticipants();

const toRankedRows = (list) =>
  buildLeaderboardRows(list, INITIAL_BALANCE).map((row) => ({
    ...row,
    mt5Login: row.mt5Login,
  }));

/** Ranked leaderboard rows shaped like the live API (includes mt5Login). */
export const getStaticLeaderboardRows = () => toRankedRows(participants);

/** Apply a simulated market tick and return re-ranked rows. */
export const tickStaticLeaderboard = () => {
  participants = participants.map((row) => ({
    ...row,
    equity: tickEquity(row.equity, INITIAL_BALANCE),
  }));
  return toRankedRows(participants);
};

export const resetStaticLeaderboard = () => {
  participants = createParticipants();
  return toRankedRows(participants);
};

export const waitForStaticFetch = (ms = STATIC_FETCH_DELAY_MS) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
